import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Tooltip, IconButton, Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchInput from 'components/SearchInput';
import { FilterBar } from 'components';
import {
  resetValues,
  updateSearchInput
} from 'store/helpers/tableAndToolbar/actions';
import clsx from 'clsx';
import { useDebounce } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center'
  },
  spacer: {
    flexGrow: 1
  },
  button: {
    marginLeft: theme.spacing(1)
  },
  filterButton: {
    margin: '0px 8px',
    fontWeight: 'normal',
    color: 'rgba(0,0,0,.55) !important',
    opacity: '1 !important'
  },
  selected: {
    color: theme.palette.primary.main,
    margin: '0px 8px'
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  backButton: {
    marginRight: '10px'
  },
  margin: {
    marginTop: '0px'
  }
}));

const Toolbar = props => {
  const {
    searchPlaceholder,
    buttonsGroup,
    action,
    searchInputSize,
    filterOptions,
    onSearch,
    showOnlyFilters
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const search = useDebounce(searchValue, 500);

  const [isSelected, setIsSelected] = React.useState(true);
  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      dispatch(updateSearchInput(''));
      return;
    }
    if(searchPlaceholder) {
      if (search.length > 2 || search === '') {
        dispatch(updateSearchInput(search.trim()));
        if (typeof onSearch === 'function') {
          onSearch(search.trim());
        } else {
          if (action) {
            dispatch(action);
          }
        }
      }
    }
  }, [search]);

  const onSearchChange = event => {
    let value = event.target.value;
    setSearchValue(value);
  };

  const handleToggle = () => {
    setIsSelected(prevOpen => !prevOpen);
  };

  const reset = () => {
    setSearchValue('');
  };

  return (
    <Card className={classes.root}>
      {!showOnlyFilters && (
        <div
          className={clsx(
            classes.row,
            searchInputSize === 'small' ? classes.margin : ''
          )}>
          {searchPlaceholder && (
            <SearchInput
              className={classes.searchInput}
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={onSearchChange}
              onClear={reset}
              style={searchInputSize === 'small' ? { padding: '4px' } : {}}
            />
          )}
          {filterOptions && (
            <Tooltip title="Show/Hide filters">
              <IconButton
                className={isSelected ? classes.selected : classes.filterButton}
                aria-label="Toggle Filters"
                onClick={handleToggle}>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          )}
          <span className={classes.spacer} />
          {buttonsGroup.length > 0 && (
            buttonsGroup.map(button => {
              return (
                <Button
                  {...(button.startIcon && { startIcon: button.startIcon })}
                  key={button.name}
                  className={classes.button}
                  color="primary"
                  variant="contained"
                  disabled={button.disabled}
                  onClick={button.action}>
                  {button.name}
                </Button>
              );
            })
          )}
        </div>
      )}
      {filterOptions && (isSelected || showOnlyFilters) && (
        <FilterBar
          filterOptions={filterOptions}
          action={action}
          selection={setIsSelected}></FilterBar>
      )}
    </Card>
  );
};

Toolbar.prototypes = {
  searchPlaceholder: PropTypes.string,
  buttonsGroup: PropTypes.array,
  action: PropTypes.func,
  searchInputSize: PropTypes.string
};

export default Toolbar;
